import React from 'react'

import { Stepper, Step, StepConnector, StepLabel, Box } from '@material-ui/core'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'

import useStepper from './useStepper'

import { Status } from '~/sale/model/sale.model'

const useStyles = makeStyles(({ spacing, palette, breakpoints }: Theme) => {
  return createStyles({
    container: {
      display: 'flex',
      backgroundColor: '#fff',
      boxShadow:
        '0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 2px 1px -1px rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.14)',
    },
    stepper: {
      padding: `${spacing(2)}px 0px`,
      maxWidth: `${breakpoints.values.xl}px`,
    },
    line: {
      borderTopWidth: '2px',
      width: spacing(8),
    },
    stepLabel: {
      margin: `0 ${spacing(4)}px`,

      '& .MuiStepLabel-active': {
        color: palette.primary,
        fontWeight: 700,
      },
    },

    icon: {
      fontWeight: 700,
      color: '#f2f2f2',

      '&$activeIcon': {
        color: palette.primary,
      },
      '&$completedIcon': {
        color: palette.grey[400],
      },
    },
    activeIcon: {},
    completedIcon: {},
  })
})
export default function StepperNavigation() {
  const { container, stepper, line, stepLabel, icon, activeIcon, completedIcon } = useStyles()
  const { activeStep, steps } = useStepper()
  return (
    <Box className={container}>
      <Stepper
        nonLinear
        className={stepper}
        connector={<StepConnector classes={{ line }} />}
        activeStep={activeStep.number}
      >
        {Object.keys(steps).map((step) => (
          <Step
            active={steps[step].status === Status.ACTIVE}
            completed={steps[step].status === Status.COMPLETED}
            disabled={steps[step].status === Status.DISABLED}
            key={`step-${steps[step].number}`}
            data-hook={`step-${steps[step].id}`}
          >
            <StepLabel
              className={stepLabel}
              StepIconProps={{
                classes: {
                  root: icon,
                  completed: completedIcon,
                  active: activeIcon,
                },
              }}
            >
              {steps[step].label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  )
}
